// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__21kWZ","filesListContainer":"PosDisputesFiles_filesListContainer__2o5m7","filesButton":"PosDisputesFiles_filesButton__23ntm"};